module.exports = __webpack_public_path__ + "static/media/bookmap.c6caee38.svg";